import styled from '@emotion/styled';
import { Grid, Typography } from '@mui/material';
import { Link } from '@/components/link/link';
import { urlFor } from '@/utils/buildImageSource';
import { VideoAsk } from '@/components/video-ask/video-ask';
import { fetchContent } from '../../lib/fetch-content';
import { useEffect, useState } from 'react';
import { ContactUsPageContent } from '../../types/contact-us-content';

const Title = styled(Typography)`
  font-family: var(--font-cooper-light), sans-serif;
  font-size: 50px;
  line-height: 109.3%;
  text-align: center;
  color: #ffffff;
  margin-bottom: 32px;
`;
const MainDiv = styled.div`
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: auto;
  padding-top: 50px;
  background: #4c3b51;
`;

const BackgroundSvg = styled.svg`
  position: relative;
`;

const LowerDiv = styled.div`
  width: 100%;
  height: auto;
  padding-bottom: 60px;
  background: #251628;
  @media (max-width: 768px) {
    padding-bottom: 150px;
  }
`;
const ContactHeaderDiv = styled.div`
  width: 100%;
  height: auto;
  text-align: center;
`;
const ContactHeaderTitle = styled(Title)`
  font-size: 28px;
  line-height: 112.3%;
  color: #ffffff;
  @media (max-width: 768px) {
    font-size: 32px;
  }
`;
const ContactCardsDiv = styled(Grid)`
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
const ContactCard = styled(Grid)`
  max-width: 105px;
  //height: 260px;
  //margin: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media (max-width: 768px) {
    max-width: 100%;
  }
`;
const ContactOption = styled(Typography)`
  font-family: var(--font-work-sans), sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 137.8%;
  text-align: center;
  color: #ffffff;
`;
const ContactDetailsDiv = styled.div`
  width: 100%;
  min-height: 60px;
  @media (max-width: 768px) {
    display: flex;

    align-items: center;
    justify-content: center;
  }
`;
const StyledLink = styled(Link)`
  text-decoration: none;
  color: #ffffff;
  cursor: pointer;
  transition: color 0.2s ease-in-out;

  &:hover {
    text-decoration: none;
    color: ${({ theme }) => theme.palette.common.yellow};
  }
`;

const ContactDetail = styled(Typography)`
  font-family: var(--font-work-sans), sans-serif;
  font-weight: normal;
  font-size: 16px;
  line-height: 160%;
  text-align: center;
  color: inherit;
  @media (max-width: 768px) {
    padding: 0 60px;
    margin: 0 auto;
  }
`;
const ContactIcon = styled.img`
  height: auto;
  width: 118px;
  margin: 10px auto 10px auto;
`;

const VideoAskWrapper = styled.div`
  position: relative;
  max-width: 345px;
  width: 100%;
  margin: 0 auto 1rem;

  @media (max-width: 768px) {
    width: 285px;
  }
`;

const ContactUs = () => {
  const [content, setContent] = useState<ContactUsPageContent | null>(null);

  useEffect(() => {
    const loadContent = async () => {
      const fetchedContent = await fetchContent();
      setContent(fetchedContent);
    };
    loadContent();
  }, []);

  return content ? (
    <MainDiv>
      <Title>{content?.title}</Title>
      <VideoAskWrapper>
        <VideoAsk
          url={urlFor(content?.videoAskURL)}
          title={content?.videoAskTitle}
          text={content?.videoAskText}
          fullscreen={content?.videoAskFullscreen}
        />
      </VideoAskWrapper>
      <BackgroundSvg viewBox="0 0 1440 150">
        <path
          fill="#251628"
          fillOpacity="1"
          d="M0,96L80,90.7C160,85,320,75,480,80C640,85,800,107,960,101.3C1120,96,1280,64,1360,48L1440,32L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
        />
      </BackgroundSvg>
      <LowerDiv>
        <ContactHeaderDiv>
          <ContactHeaderTitle>{`Other ways to stay in the loop`}</ContactHeaderTitle>
        </ContactHeaderDiv>
        <ContactCardsDiv container spacing={1}>
          {content?.contactOptions?.map(option => (
            <ContactCard item md={3} sm={4} xs={12} key={option._key}>
              <ContactOption>{option.optionTitle}</ContactOption>
              <ContactIcon src={urlFor(option?.icon?.asset?._ref)} alt={option.optionTitle} />
              <ContactDetailsDiv>
                <StyledLink href={option.detailLink}>
                  <ContactDetail>{option.detailText}</ContactDetail>
                </StyledLink>
              </ContactDetailsDiv>
            </ContactCard>
          ))}
        </ContactCardsDiv>
      </LowerDiv>
    </MainDiv>
  ) : (
    <div>Loading...</div>
  );
};

export default ContactUs;
